/**
 * ZoomX slot component.  @deprecated ZoomX is deprecated, please use `<[Chart].Zoom/>`  instead.
 */
export const ZoomX = () => null;
/* eslint-disable-next-line @typescript-eslint/no-deprecated */
ZoomX['displayName'] = 'ZoomX';
